import React, { FC } from 'react';
import { ComboBox, ComboBoxChangeEvent } from '@progress/kendo-react-dropdowns';
import DataItem from '../entities/DataItem';

interface Props {
    data: DataItem[],
    valueID: string,
    required: boolean,
    className: string
    validityStyles: boolean
    valueChanged: (selectedId: string) => void
}
const dropDownSelect: FC<Props> = (props) => {

    const valueChanged = (event: ComboBoxChangeEvent) => {
        if (event.value) {
            props.valueChanged((event.value as DataItem).Value)
        }
    }
    return (
        <ComboBox
            data={props.data}
            textField='Text'
            dataItemKey='Value'
            value={props.data.find(c => c.Value === props.valueID)}
            filterable={false}
            className={props.className}
            onChange={valueChanged}
            required={props.required}
            validityStyles={props.validityStyles}
            style={{ width: '100%' }}
        />)
}

export default dropDownSelect